import * as React from 'react';

import { ToriiBotWarning } from '../../utility/Icons';
import style from '../../../styles/sass/pages/Search.module.scss';
import { isMobile } from '../../../lib/getDeviceSize';

const styles = {
  emptyText: {
    color: '#323232',
    fontSize: 24,
    fontWeight: 'bold' as 'bold',
    lineHeight: '30px',
    marginBottom: 50,
    marginLeft: 'auto',
    marginRight: 'auto',
    textAlign: 'center' as 'center',
    whiteSpace: 'pre-wrap' as 'pre-wrap',
    width: isMobile() ? '100%' : 640,
  },
};
interface Props {
  emptyText: string;
  padTop?: boolean;
  bottomText?: boolean;
}

const NoResults = (props: Props) => (
  <div
    className={style.emptyResultContainer}
    style={{ paddingTop: props.padTop ? 50 : 0 }}
  >
    {!props.bottomText && <h2 style={styles.emptyText}>{props.emptyText}</h2>}
    <ToriiBotWarning />
    {props.bottomText && (
      <h2
        style={{ ...styles.emptyText, marginBottom: props.bottomText ? 0 : 50 }}
      >
        {props.emptyText}
      </h2>
    )}
  </div>
);

export default NoResults;
